import { EntityHoliday } from "../../entity/EntityHoliday";

export class DtoHolidaysDeleteRes extends EntityHoliday {
  public message: string | null = null;
}
